import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RegisterModel } from '../../models/Register.Model';
@Component({
  selector: 'app-load-documents',
  templateUrl: './load-documents.component.html',
  styleUrls: ['./load-documents.component.css']
})
export class LoadDocumentsComponent implements OnInit {
  public DocumentsForm: FormGroup;

  constructor(private http: HttpClient,
              private router: Router) {
     
  }

  ngOnInit() {
    this.loadForm();
  }

  /*
   *carga los controles de validacion del formulario 
   */
  loadForm(): void {
    
  }

  private getRequestUrl(controller, action) {
    return `${window.location.origin}/api/${controller}/${action}`;
  }

  /*
   *ejecuta el servicio de registro
   */
  async serv_register(item: RegisterModel) {
    const url = this.getRequestUrl("Usuario", "Crear");
    const body = { ObjectRequest: JSON.stringify(item) };
    let response = await this.http.post<object>(url, body)
      .toPromise()
      .catch(ex => {
        var error = ex.error.serverError ? ex.error.serverError : 'error';
        alert(error);
        return null;
      });

    if (!response) return;
    this.router.navigate(['register']);
  }


  public formValidator() {
    return false;
    //let isValid = this.validateFormPay1();

    //if (!isValid) return false;

    //if (this.addPaymentActive) isValid = this.validateFormPay2();

    //if (!isValid) return false;

    //return this.validateAddress();
  }


}
